import template from './wysiwyg-editor.html';
import controller from './wysiwyg-editor.controller';

let wysiwygEditorComponent = {
  restrict: 'E',
  bindings: {
    ngModel: '=',
    height: '@?',
    config: '<?',
    onChange: '&?',
    onBlur: '&?',
    disabled: '<?'
  },
  template,
  controller,
  require: {
    ngModelCtrl: '?ngModel'
  }
};

export default wysiwygEditorComponent;





// WEBPACK FOOTER //
// ./client/common/directives/wysiwyg-editor/wysiwyg-editor.component.js